import React, { useEffect, useState } from "react";
import { Row, Col, Button, Form, Input, Typography } from "antd";
import "./index.css";
import { useNavigate } from "react-router";
import HandleNotification from "../../common/Notification";
import { USER_LOGIN } from '../../apiServices/API_ENDPOINTS';
import { postData } from "../../apiServices/common";

const LogIn = () => {
  // Router
  const navigate = useNavigate();

  //   Antd Constants
  const { Title, Text } = Typography;

  // Form Instance
  const [form] = Form.useForm();

  // States for MFA flow
  const [showMfa, setShowMfa] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  //   Effects
  useEffect(() => {
    // Clear local storage data when lands to login page
    localStorage.clear();
  }, []);

  const handleLogIn = async (values) => {
    const query = `${USER_LOGIN}`;
    const bodyData = {
      email: showMfa ? email : values.email,
      password: showMfa ? password : values.password,
      ...(showMfa && { otp: values.otp }),
    };

    const response = await postData(query, bodyData);

    if (response && response?.code === 200) {
      if (response?.data?.mfa_required) {
        setEmail(values.email);
        setPassword(values.password);
        setShowMfa(true);
        form.resetFields(["otp"]);
        HandleNotification(
          "success",
          "bottomRight",
          "OTP Sent",
          response?.data?.message || "An OTP has been sent to your email. Please verify to login.",
        );
      } else {
        // setCookie("token", response?.data?.token);
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("name", response.data?.user?.name);
        localStorage.setItem(
          "roleInfo",
          JSON.stringify(response?.data?.user?.role_info),
        );
        localStorage.setItem("user_type", response.data?.user?.user_type);
        localStorage.setItem("user_id", response.data?.user?.id);
        localStorage.setItem("department_info", JSON.stringify(response?.data?.user?.department_info));
        navigate("/");
        window.location.reload();
      }
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        "Login Failed",
        (response && response?.message) ? (Array.isArray(response.message) ? response.message[0] : response.message) : "Please try with valid credentials!",
      );
    }
  };

  const handleBackToLogin = () => {
    setShowMfa(false);
    form.resetFields();
  };

  return (
    <>
      <Row align="middle">
        <Col className="gutter-row" span={10} offset={2}>
          <div className="main-form">
            <div className="form-header">
              <Title
                style={{
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: "30px",
                  width: "295px",
                  height: " 42px",
                  lineHeight: "42px",
                }}
              >
                {showMfa ? "MFA Verification" : "Login to Continue"}
              </Title>
              <Text
                type="secondary"
                style={{
                  fontWeight: 300,
                  fontSize: "16px",
                  textAlign: "right",
                }}
              >
                {showMfa ? "Verify OTP code to complete login" : "Welcome please enter your email address"}
              </Text>
            </div>

            <div className="login-form">
              <Form
                form={form}
                layout={"vertical"}
                name="basic"
                onFinish={handleLogIn}
                autoComplete="off"
              >
                {!showMfa ? (
                  <>
                    <Form.Item
                      label="Email"
                      style={{
                        width: "410px",
                        marginBottom: "30px",
                        height: "50px",
                        fontWeight: 600,
                      }}
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Email!",
                        },
                      ]}
                    >
                      <Input placeholder="Ex: email id" />
                    </Form.Item>

                    <Form.Item
                      label="Password"
                      name="password"
                      style={{
                        width: "410px",
                        height: "50px",
                        marginBottom: "40px",
                        fontWeight: 600,
                      }}
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!",
                        },
                      ]}
                    >
                      <Input.Password placeholder="Min. 8 characters" />
                    </Form.Item>

                    <Form.Item>
                      <Button type="primary" block htmlType="submit">
                        Login
                      </Button>
                    </Form.Item>
                  </>
                ) : (
                  <>
                    <Text
                      style={{
                        display: "block",
                        marginBottom: "20px",
                        fontSize: "14px",
                        color: "#595959",
                      }}
                    >
                      An OTP has been sent to your email <strong>{email}</strong>. It will expire in 5 minutes.
                    </Text>

                    <Form.Item
                      label="OTP Verification Code"
                      name="otp"
                      style={{
                        width: "410px",
                        height: "50px",
                        marginBottom: "40px",
                        fontWeight: 600,
                      }}
                      rules={[
                        {
                          required: true,
                          message: "Please input the OTP code!",
                        },
                      ]}
                    >
                      <Input placeholder="Enter 6-digit OTP code" maxLength={6} style={{ textAlign: "center", fontSize: "18px", letterSpacing: "2px" }} />
                    </Form.Item>

                    <Form.Item>
                      <Button type="primary" block htmlType="submit">
                        Verify & Login
                      </Button>
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                      <span onClick={handleBackToLogin} style={{ cursor: "pointer", color: "#1890ff" }}>
                        Back to Login
                      </span>
                    </Form.Item>
                  </>
                )}

                {!showMfa && (
                  <Form.Item
                    wrapperCol={{
                      offset: 8,
                      span: 16,
                    }}
                  >
                    <a className="login-form-forgot" href="/forget-password">
                      Forgot password
                    </a>
                  </Form.Item>
                )}
              </Form>
            </div>
          </div>
        </Col>
        <Col className="gutter-row" span={12}>
          <div className="aside-image"></div>
        </Col>
      </Row>
    </>
  );
};
export default LogIn;
